module.exports = {
      id: "text-usage",
      viewBox: "0 0 18.361 15.287",
      url: "/" + "sprite-6d93c42890617d6f6477c703e3b36dd9.svg#text",
      toString: function () {
        return this.url;
      }
    }